import { getRoles } from './api.service';

import {
  getRolesRequest,
  getRolesSuccess,
  getRolesFailure,
} from './actionCreators';

// eslint-disable-next-line import/prefer-default-export
export const fetchRoles = () => async (dispatch) => {
  try {
    dispatch(getRolesRequest());
    const { data } = await getRoles();
    dispatch(getRolesSuccess(data.data));
  } catch ({ message }) {
    dispatch(getRolesFailure(message));
  }
};
